import type { UploaderConfigEnum } from '../../generated';
import { ReactiveMap } from '../../utils/ReactiveMap';

export const uploaderConfigsMap = new ReactiveMap<
  UploaderConfigEnum,
  number,
  'uploaderConfigsMap'
>('uploaderConfigsMap');
